import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const SButton = styled(Button)(({ theme }) => ({
  mt: '12px',
  border: '1px solid #FFFFFF',
  height: '36px',
  width: '192px',
  color: theme.palette.common.white,
}));

export const styles = {
  collapseButton: {
    width: '29px',
    height: '48px',
    zIndex: 1300,
    top: '-24px',
    left: '11px',
    position: 'absolute',
  },
  collapseButtonContainer: {
    padding: '0px',
  },
  divider: {
    backgroundColor: 'white_color.50048',
    transform: 'translateY(4px)',
    height: '12px',
    display: 'inline-block',
    margin: '0 8px',
  },
  icon: {
    color: 'white_color.50080',
    width: '28px',
    height: '28px',
  },
  infoLinks: {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    mt: '32px',
    mb: '40px',
  },
  link: {
    fontSize: '12px',
    color: 'white_color.50048',
  },
};
